/*
 *###############################################################################
 *Module Name                   : SupplierBundleMasterContent.js                 #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Malisha Fernando                              #
 *Date                          : Thursday, April 21st 2022                     #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState } from "react"
import { CardText, Col, Row, Alert, Button, Label } from "reactstrap"
import DPTextBox from "framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import DPMultiSelectDropdown from "framework/components/DPMultiSelectDropdown"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const SupplierBundleMasterContent = ({
  CodeValue,
  CodeonChange,
  NameValue,
  NameOnChange,
  disabled,
  allCompany,
  SupplierGroups,

  show,
  AlertMsg,
  AlertColor,
  modelOpen,
  modelTrigger,
  GetSelectRow,
  disabledCode,
  CodeOnBlur,
  ErrorMsg,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,

  supplierGroup,
  company,
  setSupplierGroup,
  setCompany,
  autoCode,
  setStatus,
  status,
  menuCode
}) => {

  //*** End of useStates */
  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  const ApiURL = window.Links.ApiURL

  const columns2 = [{
    field: "BUN_CODE",
    title: "Code",
    align: "center",
  },
  {
    field: "BUN_DESC",
    title: "Description",
    align: "center",
  },];


  async function tog_backdrop() {
    modelTrigger()
  }

  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">
                <DPTextBoxButton
                  rowClass="mb-4-sm"
                  labelText="Bundle Code "
                  textType="text"
                  maxLength="5"
                  value={CodeValue}
                  onChange={CodeonChange}
                  onBlur={CodeOnBlur}
                  disabled={disabled == true ? disabled : disabledCode}
                  onButtonClick={onButtonClick}
                  btnDisable={disabled == true ? disabled : btnDisable}
                  placeholder={autoCode}
                />
                <DPTextBox
                  rowClass="mb-4-sm"
                  labelText="Bundle Name "
                  textType="text"
                  maxLength="50"
                  value={NameValue}
                  onChange={NameOnChange}
                  disabled={disabled}
                />
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Supplier Base</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={supplierGroup}
                      setSelected={setSupplierGroup}
                      options={SupplierGroups}
                      labelText={"Supplier Base"}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Company Base</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={company}
                      setSelected={setCompany}
                      options={allCompany}
                      labelText={"Company Base"}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Status</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPSwitch
                      labelText="Status"
                      checked={status}
                      onChange={setStatus}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Col>
              <Col sm={12} md={4} className="mb-4-sm">
                <Button
                  onClick={() => {
                    tog_backdrop()
                  }}
                  color="success"
                  className="btn-sm"
                  disabled={SearchDisable}
                >
                  <i
                    className="mdi mdi-search-web"
                    style={{ fontSize: "12px" }}
                  ></i>
                </Button>
              </Col>

              <DPSearchBoxDynamic
                searchData={Datatablesub}
                columns={columns2}
                defaultSorted={defaultSorted}
                mainTitle={menuName + " Search"}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modelOpen}
                toggle={modelTrigger}
                getSelect={GetSelectRow}
                APIURL={ApiURL}
                URLPath={"PROMOBUN"}
                MenuCode={menuCode}
                KeyVal={'SUP'}
                searchBy={'BUN_CODE'}
                FilterStr={groupFilter}
              />


            </Row>
          </CardText>
        </Col>
      </div>
    </React.Fragment>
  )
}

export default SupplierBundleMasterContent
